import { mount } from 'svelte';
import List from './templates/List.svelte';

export const initParticipants = () => {
  const participantElement = document.querySelector('#js-participants');

  if (!participantElement) {
    return;
  }

  mount(List, {
    target: participantElement,
    props: {
      selectable: false,
      theme: 'yellow',
    },
  });
};
